import { Injectable } from '@angular/core';
import { Action, Selector, State, Store, type StateContext } from '@ngxs/store';
import { GeneralControlActions } from '@medsurf/flat-actions';
import { ApiControlService } from '@medsurf/flat-services';
import { AuthControlState } from '../../internal';

export interface GeneralControlStateModel {
  apiVersion: string | null;
}

@State<GeneralControlStateModel>({
  name: 'generalControl',
  defaults: {
    apiVersion: null,
  }
})
@Injectable()
export class GeneralControlState {
  constructor(public store: Store,
              public apiControlService: ApiControlService) {
  }

  //<editor-fold desc="Selectors">

  @Selector([GeneralControlState])
  static apiVersion$(state: GeneralControlStateModel): string | null {
    return state.apiVersion;
  }

  //</editor-fold>

  //<editor-fold desc="Actions">

  @Action(GeneralControlActions.GetApiVersion)
  getApiVersion() {
    return this.apiControlService.sendMessage(
        new GeneralControlActions.GetApiVersionRequest()
      );
  }

  @Action(GeneralControlActions.GetApiVersionSuccess)
  getApiVersionSuccess({patchState}: StateContext<GeneralControlStateModel>,
                       {version}: GeneralControlActions.GetApiVersionSuccess) {
    patchState({
      apiVersion: version
    });
  }

  //</editor-fold>
}
